var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property, queryAssignedElements, queryAssignedNodes } from "lit/decorators.js";
import { elementTimeRange, timeRangesOverlap } from "./time-range";
let GrCheckList = class GrCheckList extends LitElement {
    constructor() {
        super();
        this.minChoices = null;
        this.maxChoices = null;
        this.numberChecked = 0;
        this.overlapTitle = null;
        // @state()
        this._selectedTimeRanges = [];
        this.addEventListener("change", (e) => {
            const target = e.target;
            if (target.type === "checkbox") {
                this.countChecked();
            }
        });
        this.countChecked();
    }
    render() {
        return html `
      <div>
        <slot></slot>
        <slot name="info">
          <p class="info">
            ${this.numberCheckedText()}
            ${this.choicesText()}
          </p>
        </slot>
      </div>
    `;
    }
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    firstUpdated(_changedProperties) {
        this.countChecked();
    }
    updated() {
        this.toggleEnabled();
    }
    countChecked() {
        this.numberChecked = this.checkedCheckboxes().length;
    }
    toggleEnabled() {
        this.collectTimeRanges();
        if (this.maxChoices !== null && this.numberChecked >= this.maxChoices) {
            this.unCheckedCheckboxes().forEach(c => this.disableCheckbox(c));
        }
        else {
            this.unCheckedCheckboxes().forEach(c => this.overlaps(c) ? this.disableOverlappingCheckbox(c) : this.enableCheckbox(c));
        }
    }
    disableCheckbox(cb) {
        cb.disabled = true;
    }
    enableCheckbox(cb) {
        var _a;
        cb.disabled = false;
        (_a = cb.parentElement) === null || _a === void 0 ? void 0 : _a.removeAttribute("title");
    }
    disableOverlappingCheckbox(cb) {
        cb.disabled = true;
        if (this.overlapTitle && cb.parentElement !== null) {
            cb.parentElement.title = this.overlapTitle;
        }
    }
    checkedCheckboxes() {
        return this.assignedDescendants("input[type=checkbox]:checked");
    }
    unCheckedCheckboxes() {
        return this.assignedDescendants("input[type=checkbox]:not(:checked):not([data-disabled])");
    }
    collectTimeRanges() {
        this._selectedTimeRanges = this.checkedCheckboxes().map(elementTimeRange).filter((c) => c !== undefined);
    }
    overlaps(checkbox) {
        const elementRange = elementTimeRange(checkbox);
        if (elementRange === undefined) {
            return false;
        }
        return this._selectedTimeRanges.some(range => timeRangesOverlap(range, elementRange));
    }
    assignedDescendants(selector) {
        return this._assignedElements.reduce((matches, element) => {
            if (element.matches(selector)) {
                matches.push(element);
            }
            const descendents = element.querySelectorAll(selector);
            if (descendents.length > 0) {
                const descendentElements = Array.from(descendents);
                matches.push(...descendentElements);
            }
            return matches;
        }, []);
    }
    choicesText() {
        return this.maxChoices !== null ? `Max choices ${this.maxChoices}` : null;
    }
    numberCheckedText() {
        switch (this.numberChecked) {
            case 1:
                return "1 choice selected";
            case null:
                return "0 choices selected";
            default:
                return `${this.numberChecked} choices selected`;
        }
    }
};
GrCheckList.styles = css `
    .info {
      color: red;
    }
  `;
__decorate([
    property({ type: Number, attribute: 'min-choices' })
], GrCheckList.prototype, "minChoices", void 0);
__decorate([
    property({ type: Number, attribute: 'max-choices' })
], GrCheckList.prototype, "maxChoices", void 0);
__decorate([
    property({ type: Number, attribute: false })
], GrCheckList.prototype, "numberChecked", void 0);
__decorate([
    property({ type: String, attribute: "overlap-title" })
], GrCheckList.prototype, "overlapTitle", void 0);
__decorate([
    queryAssignedElements()
], GrCheckList.prototype, "_assignedElements", void 0);
__decorate([
    queryAssignedNodes()
], GrCheckList.prototype, "_assignedNodes", void 0);
__decorate([
    queryAssignedNodes()
], GrCheckList.prototype, "_flatNodes", void 0);
GrCheckList = __decorate([
    customElement("gr-check-list")
], GrCheckList);
export { GrCheckList };
//# sourceMappingURL=gr-check-list.js.map